import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';


ReactDOM.render(
//   <React.StrictMode>
          <App/>
        //   </React.StrictMode>
, document.getElementById('root'));


// import React from 'react';
// import { createRoot } from 'react-dom/client';
// import './index.css';
// import App from './App';


// const container = document.getElementById('root');
// // Tạo một root
// const root = createRoot(container);
// // Render ứng dụng React vào root
// root.render(<App />);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
